import { render, staticRenderFns } from "./ViewProperties.vue?vue&type=template&id=78eb3262"
import script from "./ViewProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewProperties.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports